module.exports = __webpack_public_path__ + "media/images/guide-7-bc4a7f24edc6e416a11357bd66f95716.png";